import { IPersonalAccidentCartPlans } from "../../../../modules/personalAccident/utils/interfaces";
import { RootState } from "../../../store";
import { createSlice } from "@reduxjs/toolkit";

interface IPersonalAccidentCart {
  plans: IPersonalAccidentCartPlans;
  totalContribution: string;
  currentPayable: string;
  isCartbarOpen: boolean;
  rateModeType: string;
}

const initialState: IPersonalAccidentCart = {
  plans: {},
  totalContribution: "",
  currentPayable: "",
  rateModeType: "",
  isCartbarOpen: false
};

// eslint-disable-next-line import/no-unused-modules
export const personalAccidentCart = createSlice({
  name: "personalAccidentCart",
  initialState,
  reducers: {
    AddPlanInCart: (state, { payload }) => {
      state.plans[payload.planType] = payload.planDetails;
      state.totalContribution = payload.totalContribution;
      state.currentPayable = payload.currentPayable;
      state.rateModeType = payload.rateModeType;
    },
    RemovePlanCart: (state, { payload }) => {
      const addedPlanTypes = Object.keys(state.plans);

      const newCart: IPersonalAccidentCartPlans = {};
      addedPlanTypes.forEach(planType => {
        const isRemovingPlan = planType === payload;
        if (!isRemovingPlan) {
          newCart[planType as keyof typeof newCart] = state.plans[planType];
        }
      });

      state.plans = newCart;
    },
    updateCartBarStatus: (state, { payload }) => {
      state.isCartbarOpen = payload;
    },
    clearCartPlans: state => {
      state.plans = {};
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars, no-param-reassign
    ResetPersonalAccidentCart: state => (state = initialState)
  }
});

export const { AddPlanInCart, RemovePlanCart, updateCartBarStatus, clearCartPlans, ResetPersonalAccidentCart } = personalAccidentCart.actions;

export const getCartPlans = (state: RootState): IPersonalAccidentCartPlans => state.personalAccidentCart.plans;

export const getRateModeType = (state: RootState): string => state.personalAccidentCart.rateModeType;

export const getCurrentPayable = (state: RootState): string => state.personalAccidentCart.currentPayable;

export const getCartBarStatus = (state: RootState): boolean => state.personalAccidentCart.isCartbarOpen;

export default personalAccidentCart.reducer;
